'use client';

import clsx from 'clsx';
import { HTMLAttributes } from 'react';
import styles from './ArtistCard.module.scss';
import Image from 'next/image';

interface ArtistCardProps extends HTMLAttributes<HTMLElement> {
  artist: string;
  metricLabel: string;
  metricValue: string;
  description: string;
  mediaImage: string;

  isActive?: boolean;
  onSelect?: () => void;
}

export default function ArtistCard({
  artist,
  metricLabel,
  metricValue,
  description,
  mediaImage,
  isActive = false,
  onSelect,
  className = '',
  ...rest
}: ArtistCardProps) {
  return (
    <article
      className={clsx(styles.card, className)}
      data-active={isActive}
      onClick={onSelect}
      {...rest}
    >
      <div className={styles.imageContainer}>
        <Image src={mediaImage} alt={artist} width={324} height={464} />
        <div className={styles.meta}>
          <span className={styles.artist}>{artist}</span>
          <div className={styles.metric}>
            <div className={styles.metricDot} />
            <span className={styles.metricValue}>{metricValue}</span>
            <span className={styles.metricLabel}>{metricLabel}</span>
          </div>
        </div>
      </div>

      <div
        className={styles.cardDetails}
        aria-hidden={isActive ? 'false' : 'true'}
      >
        <p className={styles.description}>{description}</p>
      </div>
    </article>
  );
}
